export default __webpack_public_path__ + "static/media/30_tag_smoking-area.b4d9bdc4.svg";